module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/axios/index.js
// module id = 857
// module chunks = 168707334958949